// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../lib/auth';
import { PackCheckLogo } from '../components/PackCheckLogo';

export default function GoogleCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const [error, setError] = useState('');
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const search = new URLSearchParams(loc.search || window.location.search);
    const code = search.get('code');
    const state = search.get('state');
    const err = search.get('error');
    if (err) {
      setError(`Google returned: ${err}`);
      return;
    }
    if (!code) {
      setError('Missing authorization code from Google');
      return;
    }
    const expectedState = sessionStorage.getItem('pc_oauth_state');
    if (!expectedState || state !== expectedState) {
      setError('State mismatch — possible CSRF. Please try signing in again.');
      return;
    }
    sessionStorage.removeItem('pc_oauth_state');

    (async () => {
      try {
        const redirectUri = window.location.origin + '/auth/google';
        const { data } = await api.post('/auth/google', { code, redirect_uri: redirectUri });
        if (data.session_token) localStorage.setItem('pc_session_token', data.session_token);
        await refresh();
        const dest = data.user?.role === 'super_admin' ? '/admin' : '/dashboard';
        window.history.replaceState({}, document.title, dest);
        nav(dest, { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || e.message || 'Google sign-in failed');
      }
    })();
  }, [loc, nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-8"><PackCheckLogo height={36} /></div>
        {!error ? (
          <>
            <div className="dot-loader mx-auto"><span/><span/><span/></div>
            <p className="mt-6 text-sm text-muted-foreground" data-testid="google-callback-status">Finalising sign-in with Google…</p>
          </>
        ) : (
          <>
            <p className="text-severity-high font-mono text-sm" data-testid="google-callback-error">{error}</p>
            <button onClick={() => nav('/')} className="mt-6 underline text-sm">Return home</button>
          </>
        )}
      </div>
    </div>
  );
}
